import { type FC, type PropsWithChildren } from 'react'
import { twMerge } from 'tailwind-merge'
import cx from 'classnames'
import { Helmet, HelmetProvider } from 'react-helmet-async'
import { EnrollmentHYCSHeader } from '../components'

interface EnrollmentHYCSLayoutProps extends PropsWithChildren {
  className?: string
  title?: string
}

export const EnrollmentHYCSLayout: FC<EnrollmentHYCSLayoutProps> = ({ children, className, title = 'Enrollment' }) => {
  const baseClass = cx('h-full flex')
  const finalClasses = twMerge(baseClass, className)

  return (
    <>
      <HelmetProvider>
        <Helmet>
          <title>{title}</title>
          <meta
            name="description"
            content="Evergreen Wealth is a comprehensive advisory service that is a technology-driven, human-advised, and tax efficient way to manage all your money."
          />
        </Helmet>
      </HelmetProvider>
      <div className="h-full flex flex-col overflow-auto">
        <EnrollmentHYCSHeader />
        <div className="flex-1">
          <div className={finalClasses}>{children}</div>
        </div>
      </div>
    </>
  )
}
